import { all, fork } from 'redux-saga/effects';

import { notificationsCentreWatchers } from 'modules/notificationsCentre/store/watchers';
import { shopWatchers } from 'modules/shop/store/shopWatchers';

import { instrumentWatchers } from './instrument/instrumentWatchers';
import { entityWatchers } from './entity/entityWatchers';
import { loginWatchers } from './login/loginWatchers';
import { recentUsersWatchers } from './recentUsers/recentUsersWatchers';
import { searchResultWatchers } from './searchResult/searchResultWatchers';
import { announcementWatchers } from './announcement/announcementWatchers';
import { newsFeedWatchers } from './newsFeed/newsFeedWatchers';
import { dossierWatchers } from './portfolio/dossierWatchers';
import { sharedWatchers } from './shared/sharedWatchers';
import { investorRelationsWatchers } from './investor/investorWatchers';
import { creditReviewWatchers } from './creditReview/creditReviewWatchers';
import { eventsWatchers } from '../modules/events/store/eventsWatchers';
import { esgWatchers } from './esg/esgWatchers';
import { esgCoverageWatchers } from './esgCoverage/esgCoverageWatchers';

export function* startSagas() {
  yield all([
    fork(instrumentWatchers),
    fork(entityWatchers),
    fork(loginWatchers),
    fork(recentUsersWatchers),
    fork(searchResultWatchers),
    fork(announcementWatchers),
    fork(newsFeedWatchers),
    fork(dossierWatchers),
    fork(sharedWatchers),
    fork(investorRelationsWatchers),
    fork(shopWatchers),
    fork(creditReviewWatchers),
    fork(notificationsCentreWatchers),
    fork(eventsWatchers),
    fork(esgWatchers),
    fork(esgCoverageWatchers),
  ]);
}
